import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as LaughingColoredSvg } from './assets/laughing-colored.svg';

const LaughingColoredIcon = React.forwardRef((args, ref) => <SvgIcon component={LaughingColoredSvg} ref={ref} {...args} />);

export default LaughingColoredIcon;
